import { message } from "antd";
import { useState } from "react";
import { changeHouseCommand, changeHousePriority } from "../../../../api/api";

const HouseRecommend = (props) => {
  // console.log('recommend info',props);
  // const [isRecommend, setIsRecommend] = useState(props.is_recommend)
  const { id, setIsFresh } = props;
  const changeStatus = () => {
    changeHouseCommand(id, Number(!props.is_recommend)).then((res) => {
      console.log(props.id, props.is_recommend);
      props.is_recommend === 0
        ? message.success("已在首页推荐展示")
        : message.success("已取消在首页推荐展示");
      // setIsRecommend((pre) => {
      //   return pre === 0 ? 1 : 0;
      // });
      setIsFresh((pre) => {
        console.log("fresh!", pre);
        return !pre;
      });
    });
  };
  return (
    <div>
      <a onClick={changeStatus}>
        {props.is_recommend === 0 ? "首页推荐" : "取消首页"}
      </a>
    </div>
  );
};

export default HouseRecommend;
